import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';
import { removeKeys } from 'utils/object';

import actions from 'state/warnings/actionCreators';
import initialState from 'state/warnings/initial.state';

const warningsReducer = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setWarning]: (state, { payload: { warnings } }) => ({
      ...state,
      ...warnings,
    }),
    [actions.removeWarning]: (state, { payload: { warnings } }) =>
      removeKeys(warnings, state),
    [actions.cleanWarnings]: () => initialState,
  },
  initialState
);

export default warningsReducer;
